var React = require("react");
const createReactClass = require("create-react-class");
const PropTypes = require("prop-types");

var TDRedirect = createReactClass({
	propTypes: {
		ssl: PropTypes.bool,
		www: PropTypes.bool
	},
	render: function() {
		var redirectTo = "";
		if(this.props.ssl) {
			redirectTo += "https://";
		}
		if(this.props.www) {
			redirectTo += "www.";
		}

		return (
			<td className="prefix">{redirectTo}</td>
		)
	}

});

module.exports = TDRedirect;
